import { Box, Icon, Image, Text } from '@bonanza-social/moonlight';
import { useNavigation } from '@bonanza-social/navigation';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';
import { Pressable } from 'react-native';

function InviteFriendsBanner() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const onPress = useCallback(() => {
    navigation.navigate('InviteFriends');
  }, [navigation]);
  return (
    <Pressable onPress={onPress} testID='invite-friends-banner'>
      <Box
        variant="gradient"
        gradient="citrusBackground"
        padding="space-200"
        borderRadius="radius-200"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box display="flex" flexDirection="row">
          <Image
            name="inviteFriends.PostalEnvelope"
            alt="background-img"
            width={60}
            height={60}
          />
          <Box marginLeft="space-200" maxWidth={225}>
            <Text
              variant="body-m-semi"
              color="accentSurfacePrimary"
              locNS="inviteFriends"
              locKey="rfaSpinnerCircle"
            />
            <Text
              variant="body-s"
              color="accentSurfacePrimary"
              locNS="inviteFriends"
              locKey="rfaSpinFriends"
            />
          </Box>
        </Box>
        <Box minWidth={26}>
          <Icon name="arrowForward" height={26} width={26} />
        </Box>
      </Box>
    </Pressable>
  );
}

export default InviteFriendsBanner;
